import React from 'react';
import styles from './PageHeader.module.scss';
import { Button, Heading, Icon, IconList } from 'components/core';

const PageHeader = ({
  backLink,
  headerText,
  rightContent,
}: {
  backLink?: string;
  headerText: string;
  rightContent?: () => JSX.Element | null;
}) => {
  return (
    <div className={styles.pageHeader} data-testid="page-header">
      <div className={styles.container}>
        <div className={styles.leftSection}>
          {backLink && (
            <Button
              to={backLink}
              className={styles.backLink}
              iconOnly
              variant="outline"
              size="md"
            >
              <Icon
                icon={IconList.light.faArrowLeft}
                aria-label="Navigate back"
                aria-hidden="false"
              />
            </Button>
          )}
          <Heading
            type="h1"
            component="h2"
            variant="brand"
            className={styles.headerText}
          >
            {headerText}
          </Heading>
        </div>
        <div className={styles.rightLink}>
          {rightContent ? rightContent() : null}
        </div>
      </div>
    </div>
  );
};

export default PageHeader;
